import React, { useState, useEffect } from 'react';
import { View, FlatList, Text } from 'react-native';
import { doc, getDoc, deleteDoc } from 'firebase/firestore';
import THEME from '../../../config/theme';
import { Feather, FontAwesome } from '@expo/vector-icons';
import { firestore } from '../../../services/firebase';
import { Avatar, ViewComment, ViewAvatar } from '../style';
import LogoMain from '../../../../assets/LogoMain.png';
import { aspectRatioLogoMain } from '../../../config/data';
import { TouchableOpacity } from 'react-native-gesture-handler';
import { FooterText } from '../../../config/theme/globalStyles';
import { Image } from 'react-native';
import { useUser } from '../../../queries/userQuery';
import { useCustomTheme } from '../../../contexts/useCustomTheme';
import { useCustomImages } from '../../../api/Brand';

const ChatItem = ({
  chat,
  setIsLoading,
  pinnedChatId,
  togglePin,
  categoryId,
  cardId,
  videoId
}) => {
  const [userComment, setUserComment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [commentCreatedAt, setCommentCreatedAt] = useState(null);

  const { data: logo, isLoading: isLoadingLogo } = useCustomImages('logoApp');

  const { customColor, customFont } = useCustomTheme();

  const { data: userData } = useUser();

  const fetchUser = async () => {
    const docRef = doc(firestore, 'users', chat?.userId);
    const docSnap = await getDoc(docRef);

    if (!docSnap.exists()) return;
    setUserComment(docSnap.data());
    setLoading(false);
    setIsLoading(false);
  };

  useEffect(() => {
    fetchUser();
    if (chat.createdAt) {
      setCommentCreatedAt(
        timeAgo(new Date(chat.createdAt.toDate().toString()))
      );
    }
  }, []);

  const timeAgo = (date) => {
    const seconds = Math.floor((new Date() - date) / 1000);

    let interval = Math.floor(seconds / 31536000);

    if (interval > 1) {
      return 'há ' + interval + ' anos';
    }

    interval = Math.floor(seconds / 2592000);
    if (interval > 1) {
      return 'há ' + interval + ' meses';
    }

    interval = Math.floor(seconds / 86400);

    if (interval > 1) {
      return 'há ' + interval + ' dias';
    }

    interval = Math.floor(seconds / 3600);

    if (interval > 1) {
      return 'há ' + interval + ' horas';
    }

    interval = Math.floor(seconds / 60);
    if (interval > 1) {
      return 'há ' + interval + ' minutos';
    }

    if (seconds < 10) return 'agora';

    return 'há ' + Math.floor(seconds) + ' segundos';
  };

  const handleDeleteComment = async (chatId) => {
    try {
      const commentRef = doc(
        firestore,
        'categories',
        categoryId,
        'cards',
        cardId,
        'videos',
        videoId,
        'chats',
        chatId
      );

      await deleteDoc(commentRef);
    } catch (error) {
      console.error('Error deleting comment on chat: ', error);
    }
  };

  return (
    !loading && (
      <ViewComment>
        {userData?.isAdmin && (
          <>
            <TouchableOpacity
              onPress={() => handleDeleteComment(chat.id)}
            >
              <FontAwesome
                name="trash-o"
                size={22}
                color={
                  customColor && customColor.text && customColor.text.app
                    ? customColor.text.app
                    : THEME.COLORS.TITLE_MAIN
                }
              />
            </TouchableOpacity>
            <TouchableOpacity
              onPress={() => togglePin(chat.id)}
              style={{ marginTop: 4 }}
            >
              <Text style={{ color: 'blue', fontSize: 12 }}>
                {chat.id === pinnedChatId ? 'Desafixar' : 'Fixar'}
              </Text>
            </TouchableOpacity>
          </>
        )}
        <ViewAvatar>
          {userData?.isAdmin && chat?.userId === userData?.id ? (
            <Avatar
              resizeMode="contain"
              width={aspectRatioLogoMain * 48}
              source={logo ? logo.url : LogoMain}
            />
          ) : (
            <>
              {userComment?.photo || userComment?.userPhoto ? (
                <Image
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 100,
                    marginRight: 8,
                  }}
                  source={{ uri: userComment?.photo || userComment?.userPhoto }}
                />
              ) : (
                <Feather
                  name="user"
                  size={24}
                  color={
                    customColor && customColor.primary
                      ? customColor.primary
                      : THEME.COLORS.PRIMARY_900
                  }
                />
              )}
            </>
          )}
        </ViewAvatar>
        <View style={{ flex: 1, paddingLeft: 5 }}>
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
            }}
          >
            <FooterText
              color={
                customColor && customColor.text && customColor.text.app
                  ? customColor.text.app
                  : THEME.COLORS.TITLE_MAIN
              }
              textAlign="left"
              style={{
                fontFamily:
                  customFont && customFont.fontFamilyText
                    ? customFont.fontFamilyText
                    : THEME.FONTFAMILY.REGULAR,
                fontWeight: 'bold',
                fontSize:
                  customFont && customFont.fontSM
                    ? customFont.fontSM
                    : THEME.FONTSIZE.SMALL,
              }}
            >
              {userComment?.Nome_Completo}
            </FooterText>
          </View>
          <View>
            <FooterText
              color={
                customColor && customColor.text && customColor.text.app
                  ? customColor.text.app
                  : THEME.COLORS.TEXT_MAIN
              }
              style={{
                fontFamily:
                  customFont && customFont.fontFamilyText
                    ? customFont.fontFamilyText
                    : THEME.FONTFAMILY.REGULAR,
                fontSize:
                  customFont && customFont.fontSM
                    ? customFont.fontSM
                    : THEME.FONTSIZE.SMALL,
              }}
              textAlign="left"
            >
              {chat.chat}
            </FooterText>

            <View
              style={{
                flexDirection: 'row',
                paddingTop: 4,
                width: '100%',
              }}
            >
              <FooterText
                textAlign="left"
                style={{
                  fontFamily:
                    customFont && customFont.fontFamilyText
                      ? customFont.fontFamilyText
                      : THEME.FONTFAMILY.LIGHT,
                  fontSize:
                    customFont && customFont.fontXS
                      ? customFont.fontXS
                      : THEME.FONTSIZE.EXTRASMALL,
                }}
                color={
                  customColor && customColor.text && customColor.text.app
                    ? customColor.text.app
                    : THEME.COLORS.TEXT_MAIN
                }
              >
                {commentCreatedAt}
              </FooterText>
            </View>
          </View>
        </View>
      </ViewComment>
    )
  );
};

export default ChatItem;


